<template>
  <v-list-item ripple :disabled="disabled" tag="a" @click="$emit('click')">
    <v-list-item-icon class="list-item__icon" v-if="$slots.icon">
      <slot name="icon" />
    </v-list-item-icon>
    <v-list-item-content class="list-item__content">
      <v-list-item-title>
        <slot />
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'ListItem',
  props: {
    icon: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.list-item__icon {
  margin-right: 16px !important;
}

.list-item__content {
  padding-right: 8px !important;
}
</style>
